import grey from "@mui/material/colors/grey";
import {red} from "@mui/material/colors";
import zIndex from "@mui/material/styles/zIndex";


export const useSxStyles = {
    form: {
        gap: '1',
        width: '100%',
    },
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    login: {
        minWidth: "30vh",
        padding: "1rem",
        marginTop: "6rem"
    },
    passwd: {
        padding: "1rem",
        marginTop: "2rem",
        textAlign: "center",
        backgroundColor: 'palette.background.paper',
    },
    gridBottom: {
        marginBottom: '1rem'
    },
    displayLabel: {
        textAlign: 'right',
        color: 'royalblue'
    },
    displayValue: {
        textAlign: 'left',
        // color: theme.palette.text.primary,
    },
    countdown: {
        color: red[800]
    },
    alertContainer: {
        marginTop: "1rem",
    },
    error: {
        color: '#ff0000'
    },
    inputLabel: {
        color: 'royalblue',
        paddingRight: '8px',
        marginBottom: '.4rem'
    },
    divider: {
        borderTop: '2px solid',
        borderTopColor: 'divider'
    },
    title: {
            color: '#775ED3',
            textAlign: "left",
            marginTop: '.1rem',
            fontSize: "2rem",
            fontStyle: "normal"
    },
    toolbar: {
        padding: ".1rem",
        margin: ".1rem",
    },
    controlPanel: {
        padding: "1rem",
        marginTop: "1rem",
        textAlign: "left",
        backgroundColor: 'palette.background.paper'
    },
    formControl: {
        gap: "1rem",

    },
    formFields: {
        marginLeft: '1rem',
    },
    listContainer: {
        paddingLeft: '1rem',
        paddingRight: '1rem',
        fontSize: '1.2rem',
        backgroundColor: 'palette.background.paper',
    },
    list: {
        width: '100%',
        backgroundColor: 'palette.background.paper',
        padding: '0',
        marginBottom: '1rem'
    },
    listPadding: {
        padding: '.3rem',
        overflow: 'hidden'
    },
    listText: {
        margin: '2px 0'
    },
    tableContainer: {
        maxHeight: '72vh',
    },
    tableCell: {
        padding: '0 1rem',
    },
    listDivider: {
        backgroundColor: 'slategrey'
    },
    inline: {
        display: 'inline',
    },
    margin: {
        gap: '1',
    },
    button: {
        margin: '16px',

    },
    squashedButton: {
        height: '2rem',
        marginTop: '0',
        margin: '.5rem'
    },
    tinyButton: {
        height: '1.6rem',
        fontSize: '.7rem'
    },
    checkbox: {
        margin: '0',
        transform: 'scale(.9)',
        height: '.9rem'
    },
    textbox: {
        height: '.2rem',
        paddingTop: '.9rem',
        paddingBottom: '.9rem'
    },
    numberbox: {
        height: '2rem',
    },
    select: {
        backgroundColor: 'paper.background',
        height: '2rem'
    },
    backdrop: {
        zIndex: (theme) => zIndex.drawer + 1,
        color: '#fff',
    },
    label: {
        textAlign: 'right'
    },
    labelColor: {
        color: 'royalblue'
    },
    value: {
        textAlign: 'left'
    },
    valueRight: {
        fontSize: '.9rem',
        textAlign: 'right',
        paddingRight: '2rem'
    },
    dialog: {
        backgroundColor: 'transparent',
    },
    smallText: {
        fontSize: '.9rem',
    },
    menuText: {
        fontSize: '1rem',
        backgroundColor: "#fafafa#3f51b5",
        color: "#3f51b5"
    },
    menuTextDivider: {
        color: "#3f51b5",
        middle: 'true',
    },
    menuRoot: {
        flexGrow: 1,
        marginBottom: 15
    },
    menuButton: {
        marginRight: '16px',
    },
    menuTitle: {
        flexGrow: 1,
        textAlign: "right",
        marginTop: '.5rem',
        fontSize: "2rem",
        fontStyle: "italic",
        fontWeight: "bold"
    },
    header: {
        marginTop: '1.2rem',
    },
    users: {
        paddingLeft: '1rem',
        paddingRight: '1rem',
        fontSize: '1.2rem',
        maxHeight: '65vh',
    },
    user: {
        marginLeft: "1.5rem",
        fontSize: "0.9rem"
    },
    listBackground: {
        backgroundColor: grey[50],
    },
    listItem: {
        padding: '0',
    },
    listItemDisabled: {
        padding: '0',
        backgroundColor: '#ffcccb'
    },
    text: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: '1rem'
    },
    bold: {
        fontWeight: "bold",
    },
    textCopyright: {
        color: "white",
        fontWeight: "bold",
        paddingLeft: "0.5rem"
    },
    gridCopyright: {
        textAlign: "left",
        backgroundColor: "#3f51b5",
    },

    textTandC: {
        color: "white",
        fontWeight: "bold",
        paddingLeft: "0.5rem"
    },
    gridTandC: {
        textAlign: "left",
        backgroundColor: "#3f51b5",
    }
};
